import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { QRCodeSVG } from 'qrcode.react';
import { FaUser, FaPhone, FaMapMarkerAlt, FaIdCard, FaCalendarAlt } from 'react-icons/fa';
import { BsBuilding, BsCreditCard } from 'react-icons/bs';
import { Header } from '../components';
import { GridComponent, ColumnsDirective, ColumnDirective, Inject, Page, Toolbar } from '@syncfusion/ej2-react-grids';
import { useGetAnalyticsQuery } from '../redux/analytics';
import {  useGetRedevableQuery,  } from '../redux/redevableService';

// Import des hooks Redux (à adapter selon vos endpoints)
// import { , useGetRedevancesQuery } from '../redux/redevables';
import { redevancesData } from './../data/dummy';
import { useLazyGetRedevanceAnalyseByIdQuery, useLazyGetRedevanceByIdQuery, useLazySearchRedevancesByRedevableNameQuery } from '../redux/redevanceService';
import { analyticsSlice } from './../redux/analytics';

function UsagerDetails() {
  const { id } = useParams();
  const [unpaidRedevances, setUnpaidRedevances] = useState([]);
 const [getRedevancesAnalyseById, { data: redevancesAnalyseData }] =
    useLazyGetRedevanceAnalyseByIdQuery();
  // Récupération des données de l'usager
  const { data: usagerData, isLoading: usagerLoading, error: usagerError } = useGetRedevableQuery(id);

  const [analytics, setAnalytics] = useState(null);
  

// const usagerData = useLocation().state;
// const usagerLoading = false;
// const usagerError = null;

  // Récupération des redevances de l'usager
 

  const [searchRedevances, { data: redevancesData2, isLoading: redevancesLoading2 }] = useLazySearchRedevancesByRedevableNameQuery()

  const usager = usagerData?.data?.attributes;

  // Calculs des statistiques
  const totalPaid = redevancesAnalyseData?.redevance_payer

  const totalUnpaid = redevancesAnalyseData?.redevance_non_payer
  const totalRedevances = redevancesAnalyseData?.redevance_totale;

  const lastPaidRedevance = redevancesData?.data
    ?.filter(r => r.attributes.status === true)
    ?.sort((a, b) => new Date(b.attributes.updatedAt) - new Date(a.attributes.updatedAt))[0];

  // Configuration du Grid pour les redevances impayées
  const redevancesGrid = [
    { field: 'date', headerText: 'Date d\'échéance', width: '150', textAlign: 'Center' },
    { field: 'montant', headerText: 'Montant (FCFA)', width: '150', textAlign: 'Right', format: 'N0' },
    { field: 'type', headerText: 'Type', width: '120' },
    { field: 'status', headerText: 'Statut', width: '100', template: statusTemplate },
  ];

  function statusTemplate(props) {
    return (
      <span className={`px-2 py-1 rounded-full text-xs ${
        props.status ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
      }`}>
        {props.status ? 'Payée' : 'Impayée'}
      </span>
    );
  }

  useEffect(() => {
    if (usager) {
        searchRedevances({ name: usager.name, page: 1, size: 100 }).then(res => {

            console.log('les redevances de l usager', res.groupedRedevances?.redevances);
            const unpaid = res.groupedRedevances?.filter(r => r.redevances.attributes.status === false);
            setUnpaidRedevances(unpaid);
        });
    }
  

    if (id) {
        getRedevancesAnalyseById(id);
    }
    if (redevancesAnalyseData) {
        setAnalytics(redevancesAnalyseData);
        analyticsSlice.actions.setAnalytics(redevancesAnalyseData);
    }
  }, [usagerData]);

  if (usagerLoading) {
    return <div className="flex justify-center items-center h-64">Chargement...</div>;
  }

  if (usagerError || !usager) {
    return <div className="text-red-500 text-center">Erreur lors du chargement des données</div>;
  }

  return (
    <div className="m-2 md:m-10 p-2 md:p-10 bg-white rounded-3xl">
      <Header category="Usager" title={`Détails - ${usager.name}`} />
      
      {/* Sections 1 et 2 côte à côte */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
        
        {/* Section 1: Informations de l'usager */}
        <div className="bg-white p-6 rounded-2xl shadow-lg border">
          <h2 className="text-xl font-bold text-gray-800 mb-6 flex items-center">
            <FaUser className="mr-2 text-blue-600" />
            Informations Personnelles
          </h2>
          
          <div className="space-y-4">
            <div className="flex items-center">
              <BsBuilding className="mr-3 text-gray-500" />
              <div>
                <span className="text-sm text-gray-500">Nom de l'établissement</span>
                <p className="font-semibold">{usager.name}</p>
              </div>
            </div>

            <div className="flex items-center">
              <FaUser className="mr-3 text-gray-500" />
              <div>
                <span className="text-sm text-gray-500">Représentant</span>
                <p className="font-semibold">{usager.representative || 'Non renseigné'}</p>
              </div>
            </div>

            <div className="flex items-center">
              <FaPhone className="mr-3 text-gray-500" />
              <div>
                <span className="text-sm text-gray-500">Téléphone</span>
                <p className="font-semibold">{usager.phone || 'Non renseigné'}</p>
              </div>
            </div>

            <div className="flex items-center">
              <FaIdCard className="mr-3 text-gray-500" />
              <div>
                <span className="text-sm text-gray-500">NIF</span>
                <p className="font-semibold">{usager.nif || 'Non renseigné'}</p>
              </div>
            </div>

            <div className="flex items-center">
              <FaIdCard className="mr-3 text-gray-500" />
              <div>
                <span className="text-sm text-gray-500">NINA</span>
                <p className="font-semibold">{usager.nina || 'Non renseigné'}</p>
              </div>
            </div>

            <div className="flex items-center">
              <FaMapMarkerAlt className="mr-3 text-gray-500" />
              <div>
                <span className="text-sm text-gray-500">Adresse</span>
                <p className="font-semibold">{usager.adresse_details || 'Non renseignée'}</p>
                <p className="text-sm text-gray-600">
                  {usager.quartier?.data?.attributes?.name && `${usager.quartier.data.attributes.name}, `}
                  {usager.bureau?.data?.attributes?.name}
                </p>
              </div>
            </div>

            <div className="flex items-center">
              <FaCalendarAlt className="mr-3 text-gray-500" />
              <div>
                <span className="text-sm text-gray-500">Date d'inscription</span>
                <p className="font-semibold">
                  {new Date(usager.createdAt).toLocaleDateString('fr-FR')}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Section 2: QR Code et Statistiques */}
        <div className="space-y-6">
          {/* QR Code */}
          <div className="bg-white p-6 rounded-2xl shadow-lg border text-center">
            <h3 className="text-lg font-bold text-gray-800 mb-4">QR Code</h3>
            <div className="flex justify-center">
              <QRCodeSVG 
                value={`usager-${id}`} 
                size={150}
                bgColor="#ffffff"
                fgColor="#000000"
                level="M"
              />
            </div>
          </div>

          {/* Statistiques de paiement */}
          <div className="bg-white p-6 rounded-2xl shadow-lg border">
            <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center">
              <BsCreditCard className="mr-2 text-green-600" />
              Statistiques de Paiement
            </h3>
            
            <div className="space-y-4">
              <div className="flex justify-between items-center p-3 bg-green-50 rounded-lg">
                <span className="text-gray-600">Total payé</span>
                <span className="font-bold text-green-600">{totalPaid?.toLocaleString()} FCFA</span>
              </div>
              
              <div className="flex justify-between items-center p-3 bg-red-50 rounded-lg">
                <span className="text-gray-600">Reste à payer</span>
                <span className="font-bold text-red-600">{totalUnpaid?.toLocaleString()} FCFA</span>
              </div>

                <div className="flex justify-between items-center p-3 bg-yellow-50 rounded-lg">
                <span className="text-gray-600">Montant total des redevances</span>
                <span className="font-bold text-yellow-600">{totalRedevances?.toLocaleString()} FCFA</span>
                </div>

              
              {lastPaidRedevance && (
                <div className="p-3 bg-blue-50 rounded-lg">
                  <span className="text-gray-600 text-sm">Dernier paiement</span>
                  <p className="font-semibold text-blue-600">
                    {lastPaidRedevance.attributes.montant.toLocaleString()} FCFA
                  </p>
                  <p className="text-xs text-gray-500">
                    {new Date(lastPaidRedevance.attributes.updatedAt)?.toLocaleDateString('fr-FR')}
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Section 3: Liste des redevances impayées */}
      <div className="bg-white p-6 rounded-2xl shadow-lg border">
        <h2 className="text-xl font-bold text-gray-800 mb-6">
          Redevances Impayées ({unpaidRedevances?.length})
        </h2>
        
        {unpaidRedevances?.length > 0 ? (
          <GridComponent
            dataSource={unpaidRedevances}
            allowPaging={true}
            pageSettings={{ pageSize: 10 }}
            className="rounded-lg"
          >
            <ColumnsDirective>
              {redevancesGrid.map((item, index) => (
                <ColumnDirective key={index} {...item} />
              ))}
            </ColumnsDirective>
            <Inject services={[Page, Toolbar]} />
          </GridComponent>
        ) : (
          <div className="text-center py-8 text-gray-500">
            <p className="text-lg">🎉 Aucune redevance impayée</p>
            <p className="text-sm">Cet usager est à jour dans ses paiements</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default UsagerDetails;